// extracted by mini-css-extract-plugin
module.exports = {"linkableItem":"style_linkableItem__1h-B4TMr-iPQgzh_n1aq_e"};